import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt } from "@fortawesome/pro-solid-svg-icons";
import { getCurrencyBadge, navigateToDetailPage } from "../../helpers/common";
import React, { useRef } from "react";
import useTranslationCustom from "../../i18n/customHook/useTranslation";
import { useDispatch, useSelector } from "react-redux";
import { getLoginConfig } from "../../redux/slices/loginconfigSlice";
import { getSearchFilters } from "../../redux/slices/searchFilterSlice";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import ExpediaLogo from "../../assets/images/icons/expedia-logo-new.png";
import { isAnywhereOffersMessage } from "./chatHelpers";

export const HotelItemMapCard = ({ item, chatItem }) => {
    const offer_item = item;
    const dispatch = useDispatch();
    const { T } = useTranslationCustom();
    const navigate = useNavigate();
    const loginConfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);

    const deeplink = chatItem?.messageData?.deeplinkList;
    // An Anywhere search opens the hotel's own Expedia offer, ahead of the message deeplink.
    const anywhereUrl = isAnywhereOffersMessage(chatItem)
        ? offer_item?.roomTypes?.[0]?.links?.webDetails?.href || null
        : null;
    const isExpediaOffer = Boolean(anywhereUrl || (deeplink && offer_item?.id));

    // Slick's mobile carousel fires a click on the card after a swipe, so a card
    // level handler needs to ignore pointer gestures that turned out to be drags.
    const pointerStart = useRef(null);

    const handlePointerDown = (event) => {
        pointerStart.current = { x: event.clientX, y: event.clientY };
    };

    const isDragGesture = (event) => {
        const start = pointerStart.current;
        pointerStart.current = null;
        if (!start) return false;
        return Math.abs(event.clientX - start.x) > 10 || Math.abs(event.clientY - start.y) > 10;
    };

    const handleCardClick = (event) => {
        if (isDragGesture(event)) return;
        handleOnClick();
    };

    const handleCardKeyDown = (event) => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleOnClick();
        }
    };

    const handleOnClick = () => {
        if (anywhereUrl) {
            window.open(anywhereUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        if (deeplink && offer_item?.id) {
            let deeplinkUrl = deeplink + `&propertyId=${offer_item?.id}&selected=${offer_item?.id}&hotelId=${offer_item?.id}`;
            window.open(deeplinkUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        navigateToDetailPage(
            offer_item,
            dispatch,
            loginConfig,
            searchfilters,
            navigate,
            "hotel",
            null,
            false,
            true,
            null, // Branch data null
        );
    };

    return (
        <div
            className="packages-card-list clickable-offer-card"
            role="button"
            tabIndex={0}
            onPointerDown={handlePointerDown}
            onClick={handleCardClick}
            onKeyDown={handleCardKeyDown}
        >
            <div className="small-card-image-holder">
                <img
                    src={
                        offer_item?.thumbnailUrl ||
                        "https://www.geniustravel.com/background-image-banner.jpg"
                    }
                    className="covered-image"
                    alt={"hotel-image"}
                />
            </div>
            <div className="small-card-content-holder">
                <div>
                    <h4 className="heading heading-6 dark-text font-poppings">
                        {offer_item?.name}
                    </h4>
                    <p className="location">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        {offer_item?.address}
                    </p>
                </div>
                <div className="price-holder">
                    <div className="price">
                        {`${getCurrencyBadge(offer_item?.perPersonPrice?.currency)}${offer_item?.perPersonPrice?.totalPrice}`}
                        <span>/p.p</span>
                    </div>
                    <div className="action">
                        {isExpediaOffer && (
                            <img
                                className="expedia-logo"
                                src={ExpediaLogo}
                                alt={"expedia"}
                            />
                        )}
                        <a
                            className="action-btn"
                            tabIndex={-1}
                        >
                            {T("Buttons:View")}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

HotelItemMapCard.propTypes = {
    item: PropTypes.object,
    chatItem: PropTypes.object
}

export default HotelItemMapCard;

